import React, { useEffect, useState } from "react";
import { ArrowUpRight, Handshake } from "lucide-react";
import { PARTNERS, GALLERY, ABOUT, BOOKING_URL } from "../../mock/mock";
import { fetchPublic, resolveImg } from "../adminApi";
import { useSettings } from "../useSiteData";
import D2Banner from "../D2Banner";
import { Reveal, SplitWords } from "../motionHelpers";

export default function PartnersPage2() {
  const [partners, setPartners] = useState(PARTNERS);
  const settings = useSettings();
  useEffect(() => {
    fetchPublic("partners").then((d) => { if (d && d.length) setPartners(d); }).catch(() => {});
  }, []);
  const bannerImg = resolveImg(settings?.banners?.partners || GALLERY[1]);
  const rtImg = resolveImg(settings?.about?.rt_image || ABOUT.rt.image);
  const rtTitle = settings?.about?.rt_title || ABOUT.rt.title;
  const rtBody = settings?.about?.rt_body || ABOUT.rt.body;
  return (
    <div>
      <D2Banner eyebrow="Better Together" title="Partners & Sponsors" subtitle="Built together with the best in the game. Meet the brands and partners powering The Supreme Courts." image={bannerImg} crumbs={[{ label: "Partners & Sponsors" }]} />

      <section className="d2-bg py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {partners.map((p, i) => (
              <Reveal key={p.id || p.name} delay={i * 0.06}>
                <div data-hover className="group d2-card border border-white/10 bg-[#0b241a] rounded-2xl p-8 h-full flex flex-col items-center justify-center text-center hover:border-sc-lime transition-colors">
                  {p.logo ? (
                    <img src={resolveImg(p.logo)} alt={p.name} className="h-12 w-auto max-w-[120px] object-contain mb-4" />
                  ) : (
                    <div className="w-14 h-14 rounded-full bg-sc-lime flex items-center justify-center mb-4 group-hover:rotate-12 transition-transform">
                      <Handshake className="w-6 h-6 text-[#06170f]" />
                    </div>
                  )}
                  <div className="font-display uppercase text-2xl text-white">{p.name}</div>
                  <div className="font-mono2 uppercase text-[11px] tracking-widest text-sc-lime mt-1">{p.type}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-sc-cream py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center">
          <Reveal>
            <span className="font-grotesk uppercase tracking-[0.3em] text-sc-orange text-sm">Owner & Operator</span>
            <h2 className="font-display uppercase text-sc-green text-4xl md:text-6xl leading-[0.92] mt-3">
              <SplitWords text={rtTitle} />
            </h2>
            <p className="text-gray-600 text-lg mt-6 font-grotesk">{rtBody}</p>
          </Reveal>
          <Reveal delay={0.12}>
            <img src={rtImg} alt="RT Sports" className="w-full h-[380px] object-cover rounded-2xl shadow-2xl" />
          </Reveal>
        </div>
      </section>

      <section className="d2-bg py-20">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-8 text-center">
          <h2 className="font-display uppercase text-white text-4xl md:text-6xl">Interested in Partnering?</h2>
          <p className="text-white/60 mt-3 max-w-xl mx-auto font-grotesk">Let's put your brand on the court. Reach out about sponsorships, court branding and event partnerships.</p>
          <a href={BOOKING_URL} className="d2-btn inline-flex items-center gap-3 px-8 py-4 mt-6 text-sm">Get in Touch <ArrowUpRight className="w-4 h-4" /></a>
        </div>
      </section>
    </div>
  );
}
